import * as React from 'react';
import { css } from 'aphrodite/no-important';
import * as models from 'models/index';
import { Connect } from 'store/index';
import { style } from './style';

class FbError extends React.Component<models.store.IAppProps> {
  componentWillUnmount(): void {
    this.props.loginFn.setFbError('');
  }

  render() {
    const { copy, buttons } = this.props.copyData.text.errors[`fb_${this.props.loginProps.fbError}`];
    const { stylesData } = this.props;

    const styles = style({
      fbErrorStyles: stylesData.errors.fbPermissions,
      buttonStyles: stylesData.errors.fbPermissions.buttons.error,
      globalStyles: stylesData.global
    });

    return (
      <div className={css(styles.fbPermissions)} aria-live='assertive'>
        <h1 className={css(styles.headline)}> {copy.headline} </h1>
        <p className={css(styles.description)}> {copy.description} </p>

        <button
          aria-label='Try again'
          className={css(styles.facebook_button)}
          onClick={() => this.props.loginFn.setFbError('')}>
          {buttons.error.copy}
        </button>
      </div>
    );
  }
}

export default Connect(FbError);
